import { render, staticRenderFns } from "./PositionDetails.vue?vue&type=template&id=081f6353"
import script from "./PositionDetails.vue?vue&type=script&lang=js"
export * from "./PositionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports